import { __decorate } from "tslib";
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from "../../services/http-client.service";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { LocationStrategy } from "@angular/common";
import { WebsiteThemeService } from "../../services/website-theme.service";
import { WebClientService } from "../../services/webclient-settings.service";
import { AuthService } from "../../services/auth.service";
let CheckProtocolModalComponent = class CheckProtocolModalComponent {
    constructor(httpClient, sanitizer, router, location, themeService, webSettingsService, auth) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.router = router;
        this.location = location;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.auth = auth;
        this.successColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.backColor = '';
        this.textColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.mainColor = '';
        this.user = {};
        this.selectedChain = '';
        this.confirmChain = false;
        this.confirmChainError = false;
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        this.selectedChain = this.data.selectedChain.chain.name + ' - ' + this.data.selectedChain.chain.description;
    }
    ngAfterViewInit() {
        const parentElement = document.querySelector('.check-protocol-text');
        parentElement.appendChild(this.popOver.nativeElement);
    }
    submit() {
        if (!this.confirmChain) {
            this.confirmChainError = true;
            return;
        }
        if (this.confirmChain && this.data.selectedChain) {
            this.success();
            this.close();
        }
    }
    close() {
        this.modal.destroy();
    }
    closeModal() {
        this.error();
        document.documentElement.style.overflowY = '';
        this.modal.destroy();
    }
    confirmChainChange() {
        if (this.confirmChainError && this.confirmChain) {
            this.confirmChainError = false;
        }
    }
};
CheckProtocolModalComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: Router },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: AuthService }
];
__decorate([
    ViewChild('popOver')
], CheckProtocolModalComponent.prototype, "popOver", void 0);
CheckProtocolModalComponent = __decorate([
    Component({
        selector: 'ecd-check-protocol-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./check-protocol-modal.component.html")).default,
    })
], CheckProtocolModalComponent);
export { CheckProtocolModalComponent };
